// extracted by mini-css-extract-plugin
export default {"custom-rules-container":"DeleteRules_custom-rules-container__XeGKQ","add-rule-button":"DeleteRules_add-rule-button__k8px8"};